import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';

export const noAuthGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    // If the user already has a token in sessionStorage, they are considered authenticated.
    // We redirect them to the dashboard to prevent accessing the login page again.
    if (authService.token) {
        router.navigate(['/dashboard']);
        return false;
    }

    // If there's no token, allow access to the route (e.g. login page).
    return true;
};
